import React from 'react';

export const SectionDefinitionCard = ({
  currentSection,
  uploadedFiles = [],
  sections = [],
  lastSelectedCompany,
  lastSelectedTicker,
  editingSectionId,
  titleOptions = [],
  periodTypeOptions = [],
  companySuggestions = [],
  tickerSuggestions = [],
  filteredCompanySuggestions = [],
  filteredTickerSuggestions = [],
  showCompanySuggestions,
  showTickerSuggestions,
  isLoadingCompanies,
  onInputChange,
  onCompanyInputChange,
  onTickerInputChange,
  onSelectCompanySuggestion,
  onSelectTickerSuggestion,
  onTitleSelection,
  onPeriodTypeSelection,
  onCancelEdit,
  onUpdateSection,
  onAddSection
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">
        {editingSectionId ? 'Edit Extraction Area' : 'Define Data Extraction Areas'}
      </h2>
      
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label htmlFor="selectedFile" className="block text-sm font-medium text-gray-700 mb-1">
              Select PDF File *
            </label>
            <select
              id="selectedFile"
              name="selectedFile"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
              value={currentSection.selectedFile}
              onChange={onInputChange}
              required
            >
              <option value="">Select a file</option>
              {uploadedFiles.map((file, index) => (
                <option key={index} value={file.name}>{file.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1">
              Company Name *
            </label>
            <div className="relative">
              <input
                type="text"
                id="companyName"
                name="companyName"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                value={currentSection.companyName}
                onChange={onCompanyInputChange}
                onFocus={() => showCompanySuggestions && filteredCompanySuggestions.length > 0}
                required
                placeholder={sections.length === 0 ? "Select or type company name" : "Last selected company shown"}
                list="companySuggestions"
              />
              
              {/* Loading indicator */}
              {isLoadingCompanies && (
                <div className="absolute right-3 top-2">
                  <svg className="animate-spin h-4 w-4 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              )}

              {/* Company suggestions dropdown */}
              {showCompanySuggestions && filteredCompanySuggestions.length > 0 && (
                <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md border border-gray-200 max-h-60 overflow-auto">
                  {filteredCompanySuggestions.map((suggestion, index) => (
                    <div
                      key={index}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
                      onMouseDown={() => onSelectCompanySuggestion(suggestion)}
                    >
                      {suggestion.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Company list from backend */}
            <datalist id="companySuggestions">
              {companySuggestions.map((company, index) => (
                <option key={index} value={company} />
              ))}
            </datalist>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label htmlFor="tickerId" className="block text-sm font-medium text-gray-700 mb-1">
              Ticker ID
            </label>
            <div className="relative">
              <input
                type="text"
                id="tickerId"
                name="tickerId"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                value={currentSection.tickerId}
                onChange={onTickerInputChange}
                onFocus={() => showTickerSuggestions && filteredTickerSuggestions.length > 0}
                placeholder="Select or type ticker ID"
                list="tickerSuggestions"
              />

              {/* Ticker suggestions dropdown */}
              {showTickerSuggestions && filteredTickerSuggestions.length > 0 && (
                <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md border border-gray-200 max-h-60 overflow-auto">
                  {filteredTickerSuggestions.map((suggestion, index) => (
                    <div
                      key={index}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
                      onMouseDown={() => onSelectTickerSuggestion(suggestion)}
                    >
                      {suggestion.ticker}
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Ticker list from backend */}
            <datalist id="tickerSuggestions">
              {tickerSuggestions.map((ticker, index) => (
                <option key={index} value={ticker} />
              ))}
            </datalist>
          </div>

          <div>
            <label htmlFor="pageRange" className="block text-sm font-medium text-gray-700 mb-1">
              Page Number/Range *
            </label>
            <input
              type="text"
              id="pageRange"
              name="pageRange"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
              value={currentSection.pageRange}
              onChange={onInputChange}
              placeholder="e.g., 5 or 5-12"
              required
            />
          </div>
        </div>
<div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Financial Statement Type *
  </label>
  <div className="grid grid-cols-3 gap-2">
    {titleOptions.map((title) => {
      const isSelected = currentSection.title?.includes(title);
      return (
        <button
          key={title}
          type="button"
          className={`px-3 py-2 text-sm font-medium rounded-md border transition-all ${
            isSelected
              ? 'bg-indigo-100 border-indigo-500 text-indigo-700 shadow-sm'
              : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400'
          }`}
          onClick={() => onTitleSelection(title)}
        >
          <div className="flex items-center justify-between">
            <span>{title}</span>
            {isSelected && (
              <span className="ml-2 text-indigo-600">✓</span>
            )}
          </div>
        </button>
      );
    })}
  </div>
  <p className="text-xs text-gray-500 mt-2">
    {currentSection.title?.length > 0 
      ? `Selected: ${currentSection.title.join(', ')}`
      : 'Select one or more statement types (Ctrl+Click for multiple)'
    }
  </p>
</div>

       <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Period Type *
  </label>
  <div className="flex flex-wrap gap-3">
    {periodTypeOptions.map((periodType) => (
      <button
        key={periodType}
        type="button"
        className={`px-5 py-2 text-sm font-medium rounded-md border transition-colors
          ${
            currentSection.periodType === periodType
              ? 'bg-indigo-600 border-indigo-600 text-white hover:bg-indigo-700'
              : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
          }`}
        onClick={() => onPeriodTypeSelection(periodType)}
      >
        {periodType}
      </button>
    ))}
  </div>
</div>


        <div className="pt-4">
  {editingSectionId ? (
    <div className="flex justify-end gap-4">
      <button
        type="button"
        className="min-w-[120px] bg-indigo-600 text-white px-5 py-2 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-medium transition-colors"
        onClick={onUpdateSection}
      >
        Update
      </button>
      <button
        type="button"
        className="min-w-[120px] bg-gray-300 text-gray-700 px-5 py-2 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 text-sm font-medium transition-colors"
        onClick={onCancelEdit}
      >
        Cancel
      </button>
    </div>
  ) : (
           <div className="flex justify-end">
  <button
    type="button"
    className="w-1/4 bg-indigo-600 text-white text-center py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-medium transition-colors"
    onClick={onAddSection}
  >
    Add Section
  </button>
</div>

          )}
        </div>
      </div>
    </div>
  );
};